define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTypeSpecial = void 0;
    class WaTypeSpecial extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsMaintenance", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsMaintenanceError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaTypeSpecial.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.IsMaintenance = (0, EntityUtil_1.toInt)(entity.IsMaintenance);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaTypeSpecial.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                IsMaintenance: this.IsMaintenance,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.WaTypeSpecial = WaTypeSpecial;
    Object.defineProperty(WaTypeSpecial, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaTypeSpecial"
    });
    Object.defineProperty(WaTypeSpecial, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Special Agreement"
    });
    Object.defineProperty(WaTypeSpecial, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "IsMaintenance"]
    });
    Object.defineProperty(WaTypeSpecial, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSpecial, "IsMaintenanceTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is the landowner performing maintenance at the stock route facility?"
    });
    Object.defineProperty(WaTypeSpecial, "IsMaintenanceReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSpecial.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSpecial.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSpecial.prototype, "IsMaintenance", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSpecial.prototype, "IsMaintenanceError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSpecial.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSpecial.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSpecial.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSpecial.prototype, "merge", null);
});
